import "./write.css"

export default function Write() {
  return (
    <div className="write">
        <img className="writeImage"
            src="https://blog.amboss.com/hubfs/Blog_1200x628%20%288%29.jpg" 
            alt="" 
            />
        <form className="writeForm">
            <div className="writeFormGroup">
                <label htmlFor="fileInput">
                <i className=" writeIcon fa-solid fa-plus"></i>
                </label>
                <input type="file"  id="fileInput"  style={{display:"none"}} />
                <input type="text" placeholder="Title" className="writeInput" autoFocus={true} />
            </div>
            <div className="writeFormGroup">
                <textarea 
                placeholder="Write your post..." 
                type="text" 
                className="writeInput writeText">

                </textarea>
            </div>
            <button className="writeSubmit">Publish</button>
        </form>
    </div>
  );
}
